export class Credentials {
  loginName: string = 'anon';
  password: string = 'anon';
}
